/**
 * If continue to use this, may want to think about adding the ability to add new actions to running queue.
 * This is REALLY OLD -- should be cleaned up.
 */


(function($) {

    $.AsyncQueue = function(options) {

        if ( !(this instanceof $.AsyncQueue) ) {
            return new $.AsyncQueue(options);
        }

        this.actions = []; //really an identifier -- need?
        this.dfds = [];
        this.failedActions = []; //error callbacks

        return this;  
    };


    /**
     * Create new action object to add to the queue.
     */
    $.AsyncQueue.prototype.Action = function(options) {

        this.action = options.action; // (Note: label, not really needed) -- pass in multiple obj'S
        this.method = options.method; // (Can be sync or async -- also an array)
        this.errorCB = options.errorCB;
        this.successCB = options.successCB;
        this.cxt = options.cxt; // Could rid need of bind in calls by default

        return this;
    };


    $.AsyncQueue.prototype.add = function(options) {

        var action = new this.Action(options),
            $dfd = new $.Deferred(),
            self = this;

        options.successCB && $.extend( action, {successCB: options.successCB}); // Could just as well extend the deferred
        this.actions.push(action);

        $.when( action.method.call( action.cxt ? action.cxt : this) )
            .fail( function(jqXHR) {

                // Assuming jqXHR though doesn't have to be ajax; so this not techically correct
                self.failedActions.push( $.extend( action, {
                    error: jqXHR.status + ' ' + jqXHR.statusText + ': ' + jqXHR.responseText }
                ) );

            })
            .always(function () {
                $dfd.resolve(); //always resolve all: will call success cb (failures will have $dfd.statusText)
            });

        this.dfds.push($dfd);
        return this;

    };

    /**
     *
     * Allow all to run so can get errors at end synch'ly -- done is always run b/f always
     */
    $.AsyncQueue.prototype.run = function() {

        var self = this,
            successfulActions = $.grep( this.actions, function(a, i) {
                return a.successCB && self.failedActions[i] === undefined;
            });


        return $.Deferred( function($dfd) {

             $.when.apply($, self.dfds).done( function() {

                $.each( self.failedActions, function(i, fa) { // Should really just use the deferred itself
                    fa.errorCB && fa.errorCB(); //TODO: reject - now in the ind's
                });

                 /**
                  * Optional Success Callbacks as well to run well all processed
                  * -- don't need extra callback at end of queue
                  * Wait for browser.
                  * Could add cxt and arguments
                  */
                 $.each(successfulActions, function(i, a) {
                     setTimeout.call(window, a.successCB, 0);
                 });

                $dfd.resolve();

            });

        }).promise();
    };


}(jQuery));


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/asyncQueue.js
 ** module id = 764
 ** module chunks = 0
 **/